import React from 'react';

import { IMPORTED_FROM_EXTERNAL_EMR_TOOLTIP } from './externalCustody';
import { ExternalEmrLetterMark } from './ExternalEmrLetterMark';

export interface ImportedFromExternalEmrMarkProps {
  imported?: boolean | null;
}

/**
 * Visit rows that came from the agency's external EMR (Kinnser),
 * matching the Episode Manager “E” after the status pill — not in the task name.
 */
export const ImportedFromExternalEmrMark: React.FC<
  ImportedFromExternalEmrMarkProps
> = ({ imported }) => {
  if (imported !== true) return null;

  return (
    <ExternalEmrLetterMark
      tooltip={IMPORTED_FROM_EXTERNAL_EMR_TOOLTIP}
      testId='imported-from-external-emr-mark'
    />
  );
};
